import { message } from "antd";
import { createContext, useState } from "react";


export type CommonContextType = {
	isModalOpen: boolean,
	setModelChange: (value: boolean) => void,
	isModalOpen1: boolean,
	setModelChange1: (value: boolean) => void,
	isModalOpenBS: boolean,
	setModelChangeBS: (value: boolean) => void,
	messageApi: any,
	contextHolder: any,
	editUser: any,
	setEditUser: (value: any) => void,
	editBodySize: any,
	setEditBodySize: (value: any) => void,
	editCategory: any,
	setEditCategory: (value: any) => void,
	editBodyShape: any,
	setEditBodyShape: (value: any) => void,
	list_data: any,
	setList: (value: any) => void,
	editBs: any,
	setEditBS: (value: any) => void,
	editCs: any,
	setEditCS: (value: any) => void,
	isPref: any,
	setisPref: (value: any) => void,

	prefData: any,
	setPrefData: (value: boolean) => void,

	isModalOpenSubComp: boolean,
	setModelChangeSubComp: (value: boolean) => void,
	isRadioVal: any,
	setisRadioVal: (value: any) => void,

	editData: any,
	setEditData: (value: any) => void,
};
export const CommonContext = createContext<CommonContextType | null>(null);
interface Props {
	children: React.ReactNode;
}

const CommonProvider: React.FC<Props> = ({ children }) => {
	const [messageApi, contextHolder] = message.useMessage();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isModalOpen1, setIsModalOpen1] = useState(false);
	const [isModalOpenBS, setIsModalOpenBS] = useState(false);
	const [editUser, setEditUser] = useState(null)
	const [editBodySize, setEditBodySize] = useState(null)
	const [editCategory, setEditCategory] = useState(null)
	const [editData, setEditData] = useState(null)
	const [editBodyShape, setEditBodyShape] = useState(null)
	const [list_data, setList] = useState([{}]);
	const [editBs, setEditBS] = useState(null);
	const [editCs, setEditCS] = useState(null);
    const [isPref, setisPrefBS] = useState<boolean>(false)
	const [isRadioVal, setisRadioValData] = useState<boolean>(false)
    const [prefData, setPrefDataBS] = useState<boolean>(false)
	const setModelChange = (value: boolean) => {
		setIsModalOpen(value)
	};
	const setModelChange1 = (value: boolean) => {
		setIsModalOpen1(value)
	};
	const setModelChangeBS = (value: boolean) => {
		setIsModalOpenBS(value)
	};
	const setModelChangeSubComp = (value: boolean) => {
		setIsModalOpenSubComp(value)
	};
	const setisRadioVal = (value: boolean) => {
		setisRadioValData(value)
	};
	const setisPref = (value: boolean) => {
		setisPrefBS(value)
	};
	const setPrefData = (value: boolean) => {
		setPrefDataBS(value)
	};

	const [isModalOpenSubComp, setIsModalOpenSubComp] = useState(false);
	return <CommonContext.Provider value={{ isModalOpen, setModelChange, isModalOpen1, setModelChange1, messageApi, contextHolder, editUser, setEditUser, editBodySize, setEditBodySize, editCategory, setEditCategory, editBodyShape, setEditBodyShape, list_data, setList, isModalOpenBS, setModelChangeBS, editBs, setEditBS, editCs, setEditCS, isPref, setisPref, prefData, setPrefData, isModalOpenSubComp, setModelChangeSubComp, isRadioVal, setisRadioVal, editData, setEditData}}>{children}</CommonContext.Provider>;


};

export default CommonProvider;
